import type React from 'react';

import type { SalesforceTask } from '../../../../../domain/salesforceActivity';
import { StyledEmptyStateView } from '../../styles';
import { ActivityCard } from '../ActivityCard/ActivityCard';

import { StyledActivityList } from './styles';

type Props = {
  tasks: readonly SalesforceTask[];
};

export const ActivityList: React.FC<Props> = ({ tasks }) => {
  if (!tasks.length) {
    return (
      <StyledEmptyStateView
        variant="laboratory"
        img="/images/empty-state-laboratory.svg"
        textKey="company.salesforce_activity.list.empty-state.title"
        messageKey="company.salesforce_activity.list.empty-state.message"
      />
    );
  }

  return (
    <StyledActivityList data-automation="SalesforceActivityList">
      {tasks.map((task) => (
        <ActivityCard key={task.id} task={task} />
      ))}
    </StyledActivityList>
  );
};
